import { render, staticRenderFns } from "./historyOrder.vue?vue&type=template&id=d3b3623e&scoped=true"
import script from "./historyOrder.vue?vue&type=script&lang=js"
export * from "./historyOrder.vue?vue&type=script&lang=js"
import style0 from "./historyOrder.vue?vue&type=style&index=0&id=d3b3623e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3b3623e",
  null
  
)

export default component.exports